<div class="semd-view">
    <div class="semd-header">
        <button class="header__button modal-close" (click)="closeApp($event)">
            <img src="./assets/img/svg/close-icon.svg" />
        </button>
    </div>
    <div class="semd-body">
        <article *ngFor="let text of data">
            <div>
                 <div [innerHTML]="text"></div>
            </div>
        </article>
    </div>
</div>
